import {
  getLocalStorage,
  setLocalStorage,
  clearLocalStorage,
} from '@src/data/localStorage';

const selectedLanguageKey = 'selectedLanguages';
const getLocalStorageKey = (courseId) => `${selectedLanguageKey}.${courseId}`;

const setLocalStorageLanguage = (courseId, languageCode) => {
  const localStorageKey = getLocalStorageKey(courseId);
  setLocalStorage(localStorageKey, languageCode);
};

const clearLocalStorageLanguage = (courseId) => {
  const localStorageKey = getLocalStorageKey(courseId);
  clearLocalStorage(localStorageKey);
};

const convertObjectToIndividualEntries = () => {
  // Convert the old style of storing all settings in one big dict
  // to storing an individual namespaced field for each course language setting
  const selectedLanguageSettings = getLocalStorage(selectedLanguageKey);
  if (selectedLanguageSettings === null) {
    return;
  }
  Object.keys(selectedLanguageSettings).forEach((courseId) => {
    setLocalStorageLanguage(courseId, selectedLanguageSettings[courseId]);
  });
  // Then erase the object
  clearLocalStorage(selectedLanguageKey);
};

const getLocalStorageLanguage = (courseId) => {
  if (getLocalStorage(selectedLanguageKey)) {
    convertObjectToIndividualEntries();
  }
  const localStorageKey = getLocalStorageKey(courseId);
  return getLocalStorage(localStorageKey);
};

export {
  getLocalStorageLanguage,
  setLocalStorageLanguage,
  clearLocalStorageLanguage,
};
